<template>
  <v-row
    class="mb-3"
    dense
  >
    <v-col
      class="d-flex justify-end"
      cols="12"
    >
      <v-btn
        @click="$emit('jump', section)"
        color="primary"
        size="small"
        variant="outlined"
      >
        {{ $bct('Change response') }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  section: {
    type: String,
    required: true,
  },
});

defineEmits(['jump']);
</script>
